module.exports = __webpack_public_path__ + "static/media/ca.960555ec.svg";